var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import moment from 'moment';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { CommentsWrapper } from './BacklogApplicationStyles';
import { baseColors } from '../../Themes/colors';
import { CommentsIcon } from '../../components/icons';
var COMMENT_DISPLAY_DATE_FORMAT = 'MM/DD/YYYY | hh:mm A';
var formatCommentDateTime = function (value) {
    if (!value)
        return '';
    var parsed = moment(value);
    return parsed.isValid() ? parsed.format(COMMENT_DISPLAY_DATE_FORMAT) : '';
};
var getInitials = function (name) { return ((name || '')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(function (word) { return word.replace(/[^a-zA-Z]/g, '').charAt(0).toUpperCase(); })
    .join('')); };
export var staticComments = [
    {
        Subject: 'Need Clarification On Credit Terms',
        Text: 'Hi team, I wanted to check if we can extend the payment terms to 90 days for this client. They have a solid credit history and are requesting more flexibility on the payment schedule. Let me know if you need any additional documentation.',
        CommentedBy: 'Mike Killeen',
        CommentType: 'Comment Type',
        CreatedTime: new Date().toISOString(),
    },
    {
        Subject: 'More Clarification On Credit Terms',
        Text: "Sure, I can look into this. Could you please provide the client's credit history documents with Consumer financial bank statements, Attached in docs section.",
        CommentedBy: 'You',
        CommentType: 'REPLY',
        CreatedTime: new Date().toISOString(),
    },
];
var staticCommentType = [
    {
        "DataValue": "PORTCOMMCOMPANY",
        "Description": "Portal Comment from Company"
    },
    {
        "DataValue": "SALES",
        "Description": "Sales Comment"
    },
    {
        "DataValue": "FUNDLOG",
        "Description": "Funding Log"
    },
];
var SUBJECT_MAX_LENGTH = 50;
var BacklogComments = function (_a) {
    var comments = _a.comments, onAddComment = _a.onAddComment, _b = _a.isExpanded, isExpanded = _b === void 0 ? false : _b, onExpand = _a.onExpand, onClose = _a.onClose, fixedCommentType = _a.fixedCommentType, _c = _a.maxListHeight, maxListHeight = _c === void 0 ? 300 : _c;
    var _d = React.useState(''), commentType = _d[0], setCommentType = _d[1];
    var _e = React.useState(''), subject = _e[0], setSubject = _e[1];
    var _f = React.useState(''), message = _f[0], setMessage = _f[1];
    var _g = React.useState(''), commentTypeError = _g[0], setCommentTypeError = _g[1];
    var _h = React.useState(''), subjectError = _h[0], setSubjectError = _h[1];
    var _j = React.useState(''), messageError = _j[0], setMessageError = _j[1];
    var _k = React.useState(false), isSubmitting = _k[0], setIsSubmitting = _k[1];
    var commentListRef = React.useRef(null);
    var isSubjectMaxReached = subject.length >= SUBJECT_MAX_LENGTH;
    var displayComments = comments && comments.length > 0 ? comments : [];
    var topComment = React.useMemo(function () {
        if (!displayComments.length)
            return undefined;
        return __spreadArray([], displayComments, true).sort(function (firstComment, secondComment) {
            var firstTime = new Date(firstComment.CreatedTime).getTime();
            var secondTime = new Date(secondComment.CreatedTime).getTime();
            return (Number.isNaN(secondTime) ? 0 : secondTime) - (Number.isNaN(firstTime) ? 0 : firstTime);
        })[0];
    }, [displayComments]);
    React.useEffect(function () {
        if (isExpanded && commentListRef.current) {
            commentListRef.current.scrollTop = commentListRef.current.scrollHeight;
        }
    }, [displayComments.length, isExpanded]);
    var renderReceivedComment = function (comment, compact) {
        var _a, _b;
        if (compact === void 0) { compact = false; }
        return (React.createElement(Stack, { direction: "row", gap: 1.5, sx: { py: 1.25 } },
            React.createElement(Box, { sx: {
                    width: 32,
                    height: 32,
                    borderRadius: '50%',
                    backgroundColor: baseColors.greyPreset[55],
                    color: baseColors.greyPreset[10],
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 12,
                    fontWeight: 700,
                    flexShrink: 0,
                    mt: '2px',
                } }, getInitials(comment.CommentedBy)),
            React.createElement(Stack, { sx: { minWidth: 0, flex: 1, textAlign: 'left' }, gap: 0.5 },
                React.createElement(Stack, { direction: "row", alignItems: "baseline", gap: 0.75, flexWrap: "wrap" },
                    React.createElement(Typography, { sx: { fontSize: 13, fontWeight: 700, color: baseColors.darkPreset[10] } }, comment.CommentedBy),
                    React.createElement(Typography, { sx: { fontSize: 11, color: baseColors.greyPreset[30] } }, [((_a = comment.CommentTypeDescription) === null || _a === void 0 ? void 0 : _a.trim()) || null, formatCommentDateTime(comment.CreatedTime) || null]
                        .filter(Boolean)
                        .map(function (part, index) { return (index === 0 ? part : "\u00B7 ".concat(part)); })
                        .join(' '))),
                ((_b = comment.Subject) === null || _b === void 0 ? void 0 : _b.trim()) && (React.createElement(Typography, { sx: { fontSize: 13, fontWeight: 600, color: baseColors.darkPreset[10] } }, comment.Subject)),
                React.createElement(Typography, { sx: __assign({ fontSize: 13, color: baseColors.darkPreset[10], lineHeight: 1.5 }, (compact ? {
                        display: '-webkit-box',
                        WebkitLineClamp: 4,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                    } : {})) }, comment.Text))));
    };
    function handleSend() {
        return __awaiter(this, void 0, void 0, function () {
            var trimmedSubject, trimmedMessage, nextSubjectError, nextMessageError, nextCommentTypeError, selectedType, isSuccessful;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        trimmedSubject = subject.trim();
                        trimmedMessage = message.trim();
                        if (isSubmitting) {
                            return [2];
                        }
                        nextSubjectError = !trimmedSubject
                            ? 'Subject is required'
                            : trimmedSubject.length > SUBJECT_MAX_LENGTH
                                ? "Subject cannot exceed ".concat(SUBJECT_MAX_LENGTH, " characters")
                                : '';
                        nextMessageError = trimmedMessage ? '' : 'Message is required';
                        nextCommentTypeError = fixedCommentType || commentType ? '' : 'Comment Type is required';
                        setCommentTypeError(nextCommentTypeError);
                        setSubjectError(nextSubjectError);
                        setMessageError(nextMessageError);
                        if (nextSubjectError || nextMessageError || nextCommentTypeError) {
                            return [2];
                        }
                        if (!onAddComment) {
                            setSubject('');
                            setMessage('');
                            setSubjectError('');
                            setMessageError('');
                            return [2];
                        }
                        selectedType = staticCommentType.find(function (type) { return type.DataValue === commentType; });
                        setIsSubmitting(true);
                        return [4, Promise.resolve(onAddComment({
                                subject: trimmedSubject,
                                message: trimmedMessage,
                                CommentType: fixedCommentType || {
                                    Code: (selectedType === null || selectedType === void 0 ? void 0 : selectedType.DataValue) || '',
                                    Description: (selectedType === null || selectedType === void 0 ? void 0 : selectedType.Description) || '',
                                },
                            }))];
                    case 1:
                        isSuccessful = _a.sent();
                        setIsSubmitting(false);
                        if (isSuccessful) {
                            setCommentType('');
                            setSubject('');
                            setMessage('');
                            setCommentTypeError('');
                            setSubjectError('');
                            setMessageError('');
                        }
                        return [2];
                }
            });
        });
    }
    return (React.createElement(CommentsWrapper, { sx: isExpanded ? { height: '100%', display: 'flex', flexDirection: 'column' } : undefined },
        React.createElement(Stack, { className: "commentsHeader", direction: "row", alignItems: "center", justifyContent: "space-between", width: "100%" },
            React.createElement(Stack, { direction: "row", alignItems: "center", gap: 1 },
                React.createElement(Box, { sx: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 32,
                        height: 32,
                        borderRadius: '10px',
                        backgroundColor: '#D7F5EC',
                        flexShrink: 0,
                        '& svg': { width: 18, height: 18 },
                    } },
                    React.createElement(CommentsIcon, null)),
                React.createElement(Typography, { fontSize: '14px', fontWeight: 700, color: baseColors.darkPreset[10] }, "Comments")),
            !isExpanded ? (React.createElement(Tooltip, { title: "Add new comment", arrow: true },
                React.createElement(AddCircleOutlineIcon, { onClick: onExpand, sx: {
                        fontSize: 25,
                        color: baseColors.successPreset[30],
                        cursor: 'pointer',
                    } }))) : (React.createElement(Stack, { className: "headerActions", direction: "row" },
                React.createElement(Box, { className: "headerActionBtn", onClick: onClose },
                    React.createElement("span", { className: "icon-close" }))))),
        isExpanded ? (React.createElement(React.Fragment, null,
            React.createElement(Stack, { className: "commentList", ref: commentListRef, sx: { flex: 1, minHeight: 0, overflowY: 'auto' } }, displayComments.map(function (comment, idx) { return (React.createElement(React.Fragment, { key: idx }, renderReceivedComment(comment))); })),
            React.createElement(Stack, { className: "inputArea", gap: 1.5, sx: { borderTop: "1px solid ".concat(baseColors.greyPreset[40]) } },
                !fixedCommentType && (React.createElement(Stack, { className: "commentTypeRow", direction: "row", alignItems: "center", gap: 1.5 },
                    React.createElement(Typography, { variant: "body2", className: "commentTypeLabel" }, "Comment Type"),
                    React.createElement("div", { className: "commentTypeSelectWrap" },
                        React.createElement("select", { className: "commentTypeSelect ".concat(!commentType ? 'placeholder' : ''), value: commentType, disabled: isSubmitting, onChange: function (e) {
                                setCommentType(e.target.value);
                                if (commentTypeError)
                                    setCommentTypeError('');
                            } },
                            React.createElement("option", { value: "", disabled: true }, "Select Comment Type"),
                            staticCommentType.map(function (type) { return (React.createElement("option", { key: type.DataValue, value: type.DataValue }, type.Description)); }))))),
                !fixedCommentType && commentTypeError ? (React.createElement(Typography, { variant: "caption", sx: { color: baseColors.errorPreset[10], mt: -0.5 } }, commentTypeError)) : null,
                React.createElement("input", { className: "subjectInput ".concat(isSubjectMaxReached ? 'subjectInputMaxReached' : ''), placeholder: "Subject", value: subject, maxLength: SUBJECT_MAX_LENGTH, disabled: isSubmitting, onChange: function (e) {
                        setSubject(e.target.value.slice(0, SUBJECT_MAX_LENGTH));
                        if (subjectError)
                            setSubjectError('');
                    } }),
                subjectError ? (React.createElement(Typography, { variant: "caption", sx: { color: baseColors.errorPreset[10], mt: -0.5 } }, subjectError)) : isSubjectMaxReached ? (React.createElement(Typography, { variant: "caption", sx: { color: baseColors.errorPreset[10], mt: -0.5 } },
                    "Subject cannot exceed ",
                    SUBJECT_MAX_LENGTH,
                    " characters")) : null,
                React.createElement(Stack, { className: "textareaWrap", sx: { position: 'relative' } },
                    React.createElement("textarea", { className: "messageTextarea", placeholder: "Enter Message", rows: 4, value: message, disabled: isSubmitting, onChange: function (e) {
                            setMessage(e.target.value);
                            if (messageError)
                                setMessageError('');
                        } }),
                    React.createElement(Box, { className: "sendBtn", onClick: handleSend, sx: { opacity: isSubmitting ? 0.6 : 1, pointerEvents: isSubmitting ? 'none' : 'auto' } },
                        React.createElement("span", { className: "icon-Send" }))),
                messageError ? (React.createElement(Typography, { variant: "caption", sx: { color: baseColors.errorPreset[10], mt: -0.5 } }, messageError)) : null))) : (React.createElement(Stack, { className: "commentList", sx: {
                borderBottom: 'none',
                padding: '0px 12px 16px 12px',
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: displayComments.length > 0 ? 'white' : '#F3F3F1',
                maxHeight: maxListHeight,
                overflowY: 'auto',
            } }, displayComments.length > 0 ? displayComments.map(function (comment, idx) { return (React.createElement(React.Fragment, { key: idx }, renderReceivedComment(comment, true))); }) : (React.createElement(Typography, { variant: "body2", sx: { fontStyle: 'italic', color: baseColors.greyPreset[30], display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row', backgroundColor: '#F3F3F1', } }, "No comments available"))))));
};
export default BacklogComments;
